// Upload-Dateien liegen öffentlich unter GET /api/v1/uploads/:fileId (Plan 1).
export const fileUrl = (fileId) => `${matrixPublicParams.api_url}/uploads/${fileId}`
